import { Description } from '@headlessui/react';
import { twMerge } from 'tailwind-merge';

import { useTheme } from '@/_shared';

import type { ModalBodyProps } from './types';

export const ModalBody = ({ ref, ...props }: ModalBodyProps) => {
  const { children, className, as = 'div', ...other } = props;
  const { modal } = useTheme();

  // TODO: this className should be check
  const cls = twMerge(modal.body, className as string);

  return (
    <Description as={as} className={cls} ref={ref} {...other}>
      {children}
    </Description>
  );
};
